module.exports = __webpack_public_path__ + "static/media/sheet_attendance_banner.61e7381c.svg";